// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010334/js/" + chunkId + "." + {"44":"d1ea62a0","225":"2259a492","481":"ee2eb7d4","486":"d7da5c0e","770":"64ca8da6"}[chunkId] + ".0.359065047178189.chunk.js";
};